import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { Response } from '../response';
import { CommonProvider } from '../common'

@Injectable()
export class ClubProvider {
  private needsRefresh = new BehaviorSubject(false);
  currentRefreshStatus = this.needsRefresh.asObservable();


  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) {}

  private _url: string = this.commonProvider.apiUrl + 'api/v1/club';
  
  getAll(): Observable<Response<Club[]>> {
    return this.http.get<Response<Club[]>>(this._url + '/list');
  }

  get(id: string): Observable<Response<Club>> {
    return this.http.get<Response<Club>>(this._url + `/${id}/show`);
  }

  listMembers(id: string): Observable<Response<Club>> {
    return this.http.get<Response<Club>>(this._url + `/${id}/members`);
  }

  create(post: ClubCreate): Observable<Response<Club>> {
    return this.http.post<Response<Club>>(this._url + `/create`, post);
  }

  delete(post: Club | string): Observable<Response<any>> {
    const id = typeof post == 'string' ? post : post.id;
    return this.http.post<Response<any>>(this._url + `/${id}/delete`, null);
  }

  update(clubId: string, clubData: Club | string): Observable<Response<Club>> {
    const id = clubId;
    return this.http.post<Response<Club>>(this._url + `/${id}/update`, clubData);
  }

  join(id: string): Observable<Response<Club>> {
    return this.http.post<Response<Club>>(this._url + `/${id}/user/create`, {});
  }

  leave(clubId: string, userId: string): Observable<Response<Club>> {
    return this.http.post<Response<Club>>(this._url + `/${clubId}/user/${userId}/delete`, {});
  }

  refreshStatus(status: boolean) {
    this.needsRefresh.next(status)
  }

}

export interface Club {
  id: string;
  Members?: any[];
  company_id?: string;
  user_id?: string;
  club_id?: string;
  avatar_id?: string;
  name?: string;
  description?: string;
  sponsored?: boolean;
  city?: string;
  active?: boolean;
  created_at: string;
  updated_at: string;
}


export interface ClubCreate {
    avatar?: string;
    name?: string;
    description?: string;
    city?: string;
    sponsored?: boolean;
    active?: boolean;
}




// WEBPACK FOOTER //
// ./src/providers/club/club.ts